import { loadScriptWithRequireJS } from '@wix/thunderbolt-commons'

interface Container {
	init(): Promise<void>
	get(): any
}

export async function loadComponentWithModuleFederation(moduleFederationEntryUrl: string, widgetName: string) {
	const container = (await loadScriptWithRequireJS(moduleFederationEntryUrl)) as Container
	const component = await loadComponent(container, widgetName)
	return component
}

async function loadComponent(container: Container, module: string) {
	// Initializes the share scope. This fills it with known provided modules from this build and all remotes
	// This will be replaced by using a shared scope of our own
	// @ts-ignore
	await __webpack_init_sharing__('default')
	// Initialize the container, it may provide shared modules
	// @ts-ignore
	await container.init(__webpack_share_scopes__.default)
	// @ts-ignore
	const factory = await container.get(module)
	const component = factory()
	return component
}
